import Vue from 'vue'
import VueRouter from 'vue-router'
import { tokenManager } from '@/util/token'
// import { getCookie } from '@/util/cookie'
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/dashboard' },
  { path: '/dashboard', component: () => import('@/views/Dashboard.vue') },
  { path: '/start', name: 'Start', component: () => import('@/views/Start.vue') },
  { path: '/login', name: 'Login', component: () => import('@/views/Login.vue') },
  { path: '/account-disabled', name: 'AccountDisabled', component: () => import('@/views/AccountDisabled.vue') },
  { path: '/project/add', component: () => import('@/views/settings/ProjectAdd.vue') },
  { name: 'custom', path: '/setting/custom', component: () => import('@/views/settings/Custom.vue') },
  { name: 'installSettings', path: '/setting/install_settings', component: () => import('@/views/settings/InstallSettings.vue') },
  { path: '/setting/case_field_add', component: () => import('@/views/settings/CaseFieldAdd.vue') },
  { name: 'Overview', path: '/project/overview/:projectId', component: () => import('@/views/Overview.vue') },
  {
    path: '/knowledge-base/:projectId',
    component: () => import('@/views/KnowledgeBase/KnowledgeBaseBlank.vue'),
    children: [
      {
        path: '',
        redirect: { name: 'knowledgeBaseDocuments' }
      },
      {
        name: 'knowledgeBaseDocuments',
        path: 'documents',
        component: () => import('@/views/KnowledgeBase/DocumentManage.vue')
      },
      {
        name: 'knowledgeBaseGraph',
        path: 'graph',
        component: () => import('@/views/KnowledgeBase/KnowledgeGraph.vue')
      },
      {
        name: 'knowledgeBaseChat',
        path: 'chat',
        component: () => import('@/views/KnowledgeBase/KnowledgeChat.vue')
      }
    ]
  },
  { name: 'MilestoneDetail', path: '/milestone/detail/', component: () => import('@/views/MilestoneDetail.vue') },
  { name: 'MilestonesOverview', path: '/milestones/overview/:projectId', component: () => import('@/views/MilestonesOverview.vue') },
  { name: 'MilestoneAdd', path: '/milestone/add/', component: () => import('@/views/MilestoneAddMod.vue') },
  { name: 'suitesOverview', path: '/suites/overview/:projectId', component: () => import('@/views/SuitesOverview.vue') },
  { name: 'casesOverview', path: '/cases/overview/:projectId', component: () => import('@/views/CaseView/CaseOverview.vue') },
  { path: '/case/add/:suiteId', component: () => import('@/views/CaseView/CaseAdd.vue') },
  { name: '/UserAndRole', path: '/setting/user_role', component: () => import('@/views/settings/UserAndRole.vue') },
  { path: '/superTree/', component: () => import('@/views/superTree/index.vue') },
  { path: '/CaseDialog/addCase', component: () => import('@/views/CaseDialog/AddCase.vue') },
  { path: '/setting/casefieldedit', component: () => import('@/views/settings/CaseFieldEdit.vue') },
  { path: '/setting/result_field_edit', component: () => import('@/views/settings/ResultFieldEdit.vue') },
  { path: '/role/add', component: () => import('@/views/settings/RoleAdd.vue') },
  { path: '/role/edit', component: () => import('@/views/settings/RoleEdit.vue') },
  { path: '/setting/template_add', component: () => import('@/views/settings/TemplateAdd.vue') },
  { path: '/setting/template_edit', component: () => import('@/views/settings/TemplateEdit.vue') },
  { name: '/caseDetails', path: '/cases/caseDetails/', component: () => import('@/views/CaseView/CaseDetails.vue') },
  { name: 'caseEditCases', path: '/cases/caseEditCases/', component: () => import('@/views/CaseView/caseEditCases.vue') },
  // { path: '/setting/status_add', component: () => import('@/views/settings/ResultStatusAdd.vue') },
  { path: '/setting/status_edit', component: () => import('@/views/settings/ResultStatusEdit.vue') },
  { path: '/setting/result_field_add', component: () => import('@/views/settings/ResultFieldAdd.vue') },
  { name: 'caseMinder', path: '/cases/CaseMinderView/', component: () => import('@/views/CaseView/CaseMinderView.vue') },
  { name: 'runsAndResults', path: '/testRuns/TestRunsAndResultsOverview/:projectId', component: () => import('@/views/TestRunsAndResults/TestRunsAndResultsOverview.vue') },
  { name: 'runDetail', path: '/testRuns/TestRunDetail/', component: () => import('@/views/TestRunsAndResults/TestRunDetail.vue') },
  { name: 'runTreeDetail', path: '/testRuns/TestRunTreeDetail/', component: () => import('@/views/TestRunsAndResults/TestRunTreeDetail.vue') },
    { name: 'runTreeCompletedDetail', path: '/testRuns/TestRunTreeCompletedView/', component: () => import('@/views/TestRunsAndResults/TestRunTreeCompletedView.vue') },
  { name: 'addReports', path: '/reports/AddReports/', component: () => import('@/views/Reports/AddReports.vue') },
  { name: 'caseTestResult', path: '/cases/CaseTestResult/', component: () => import('@/views/CaseTestResult.vue') },
  { name: 'testReportsOverview', path: '/reports/TestReportsOverview/:projectId', component: () => import('@/views/Reports/TestReportsOverview.vue') },
  { name: 'todoOverview', path: '/todo/TodoOverview/:projectId', component: () => import('@/views/Todo/TodoOverview.vue') },
  {
    name: 'platformAdminApiMachine',
    path: '/platform/admin/api_test/api-machine',
    component: () => import('@/views/ApiTest/managementCenter/ApiMachineManage.vue')
  },
  {
    name: 'apiTestOverview',
    path: '/api-test/:projectId',
    component: () => import('@/views/ApiTest/ApiTestLayout.vue'),
    children: [
      {
        path: '',
        redirect: 'interfaces'
      },
      {
        name: 'appApplicationManage',
        path: 'app-apps',
        component: () => import('@/views/AppAutomation/pages/applications/ApplicationManage.vue')
      },
      {
        name: 'appScriptManage',
        path: 'app-scripts',
        component: () => import('@/views/AppAutomation/pages/scripts/ScriptManage.vue')
      },
      {
        name: 'appScriptRecord',
        path: 'app-scripts/record/:scriptId?',
        meta: { fullscreen: true },
        component: () => import('@/views/AppAutomation/pages/scripts/RecordScript.vue')
      },
      {
        name: 'appTaskManage',
        path: 'app-tasks',
        component: () => import('@/views/AppAutomation/pages/tasks/TaskManage.vue')
      },
      {
        name: 'appAnnotationManage',
        path: 'app-annotations',
        component: () => import('@/views/AppAutomation/pages/annotations/AnnotationManage.vue')
      },
      {
        name: 'appDeviceManage',
        path: 'app-devices',
        component: () => import('@/views/AppAutomation/pages/devices/DeviceManage.vue')
      },
      {
        name: 'webScriptManage',
        path: 'web-scripts',
        component: () => import('@/views/ApiTest/webAutomation/scripts/WebScriptManage.vue')
      },
      {
        name: 'webScriptDetail',
        path: 'web-scripts/online/:scriptId?',
        meta: { fullscreen: true },
        component: () => import('@/views/ApiTest/webAutomation/scripts/WebScriptDetail.vue')
      },
      {
        name: 'webTaskManage',
        path: 'web-tasks',
        component: () => import('@/views/ApiTest/webAutomation/tasks/WebTaskManage.vue')
      },
      {
        name: 'webAnnotationManage',
        path: 'web-annotations',
        component: () => import('@/views/ApiTest/webAutomation/annotations/WebAnnotationManage.vue')
      },
      {
        name: 'desktopScriptManage',
        path: 'desktop-scripts',
        component: () => import('@/views/ApiTest/desktopAutomation/scripts/DesktopScriptManage.vue')
      },
      {
        name: 'desktopScriptEditor',
        path: 'desktop-scripts/editor/:scriptId?',
        component: () => import('@/views/ApiTest/desktopAutomation/scripts/DesktopScriptEditorPage.vue')
      },
      {
        name: 'desktopTaskManage',
        path: 'desktop-tasks',
        component: () => import('@/views/ApiTest/desktopAutomation/tasks/DesktopTaskManage.vue')
      },
      {
        name: 'desktopTaskReport',
        path: 'desktop-tasks/report/:recordId',
        component: () => import('@/views/ApiTest/desktopAutomation/tasks/DesktopTaskReportPage.vue')
      },
      {
        name: 'desktopAnnotationManage',
        path: 'desktop-annotations',
        component: () => import('@/views/ApiTest/desktopAutomation/annotations/DesktopAnnotationManage.vue')
      },
      {
        name: 'apiInterfaceManage',
        path: 'interfaces',
        component: () => import('@/views/ApiTest/interfaces/InterfaceManage.vue')
      },
      {
        name: 'apiScriptManage',
        path: 'scripts',
        component: () => import('@/views/ApiTest/scripts/ScriptManage.vue')
      },
      {
        name: 'apiCaseManage',
        path: 'cases',
        component: () => import('@/views/ApiTest/cases/CaseManage.vue')
      },
      {
        name: 'apiTaskManage',
        path: 'tasks',
        component: () => import('@/views/ApiTest/tasks/TaskManage.vue')
      },
      {
        name: 'apiScheduledTaskManage',
        path: 'scheduled-tasks',
        component: () => import('@/views/ApiTest/scheduledTasks/ScheduledTaskManage.vue')
      },
      {
        name: 'apiTestPlanManage',
        path: 'test-plans',
        component: () => import('@/views/ApiTest/testPlans/TestPlanManage.vue')
      },
      {
        name: 'apiGlobalVariableManage',
        path: 'global-variables',
        component: () => import('@/views/ApiTest/globalVariables/GlobalVariableManage.vue')
      },
      {
        name: 'apiDataSourceManage',
        path: 'data-sources',
        component: () => import('@/views/ApiTest/dataSources/DataSourceManage.vue')
      },
      {
        name: 'apiDataTagManage',
        path: 'data-tags',
        component: () => import('@/views/ApiTest/dataTags/DataTagManage.vue')
      },
      {
        name: 'managementOverview',
        path: 'management-overview',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'managementApiExecutorManage',
        path: 'management-api-executors',
        meta: { hideApiHeader: true },
        component: () => import('@/views/ApiTest/managementCenter/ApiMachineManage.vue')
      },
      {
        name: 'managementApiTestEnvironmentManage',
        path: 'management-api-test-environments',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'managementApiProtocolManage',
        path: 'management-api-protocols',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'managementT2ConnectionManage',
        path: 'management-t2-connections',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'managementThirdPartyScriptManage',
        path: 'management-third-party-scripts',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'managementIssueTypeManage',
        path: 'management-issue-types',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'managementStatistics',
        path: 'management-statistics',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'managementDiskManage',
        path: 'management-disks',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'managementNotificationManage',
        path: 'management-notifications',
        component: () => import('@/views/ApiTest/managementCenter/ManagementCenterBlank.vue')
      },
      {
        name: 'apiDashboardManage',
        path: 'dashboard',
        component: () => import('@/views/ApiTest/dashboards/DashboardBlank.vue')
      },
      {
        name: 'apiDataDashboardManage',
        path: 'data-dashboard',
        component: () => import('@/views/ApiTest/dashboards/DashboardBlank.vue')
      },
      {
        name: 'apiDocsManage',
        path: 'docs',
        component: () => import('@/views/ApiTest/docs/DocsManage.vue')
      },
      {
        name: 'apiDatasetManage',
        path: 'datasets',
        component: () => import('@/views/ApiTest/datasets/DatasetManage.vue')
      },
      {
        name: 'apiDataEnumManage',
        path: 'data-enums',
        component: () => import('@/views/ApiTest/dataEnums/DataEnumManage.vue')
      },
      {
        name: 'apiRecycleBinManage',
        path: 'recycle-bin',
        component: () => import('@/views/ApiTest/recycleBin/RecycleBinManage.vue')
      },
      {
        name: 'apiTestEnvironments',
        path: 'environments',
        component: () => import('@/views/ApiTest/environments/ApiTestEnvironmentManage.vue')
      }
    ]
  },
  { name: 'MilestonesOverview', path: '/milestones/MilestonesOverview/:projectId', component: () => import('@/views/Milestones/MilestonesOverview.vue') },
  { name: 'milestonesDetail', path: '/milestones/MilestonesDetail/', component: () => import('@/views/Milestones/MilestonesDetail.vue') },
  { name: 'bugOverView', path: '/bug/BugOverView/', component: () => import('@/views/BugsView/BugOverView.vue') },
  { path: '/setting/bug_field_add', component: () => import('@/views/settings/BugFieldAdd.vue') },
  { path: '/setting/bug_field_edit', component: () => import('@/views/settings/BugFieldEdit.vue') },
  { path: '/setting/bug_process_edit', component: () => import('@/views/settings/BugProcessEdit.vue') },
  { name: 'projectList', path: '/setting/ProjectList', component: () => import('@/views/settings/ProjectList.vue') },
  { path: '/setting/project_setting', component: () => import('@/views/settings/ProjectSetting.vue') },
  { name: 'requirementOverView', path: '/RequirementView/RequirementOverView/:projectId', component: () => import('../views/RequirementView/RequirementOverView.vue') },
  { name: 'reportsDetail', path: '/reports/TestReportsDetailView/', component: () => import('@/views/Reports/TestReportsDetailView.vue') },
  { name: 'reportsProjectDetail', path: '/reports/TestReportsProjectDetailView/', component: () => import('@/views/Reports/TestReportsProjectDetailView.vue') },
  { name: 'reportsPlanDetail', path: '/reports/TestReportsPlanDetailView/', component: () => import('@/views/Reports/TestReportsPlanDetailView.vue') },
  { name: 'reportsMilestoneDetail', path: '/reports/TestReportsMilestoneDetailView/', component: () => import('@/views/Reports/TestReportsMilestoneDetailView.vue') },
  { name: 'caseBatchEditView', path: '/caseView/CaseBatchEditView/', component: () => import('@/views/CaseView/CaseBatchEditView.vue') },
  { name: '/setting/user_setting', path: '/setting/user_setting', component: () => import('@/views/settings/UserSetting.vue') },
  { name: '/setting/userAddandProject', path: '/setting/UserAddAndProject', component: () => import('@/views/settings/UserAddAndProject.vue') },
  { name: '/ProjectBug/projectBugView', path: '/ProjectBug/ProjectBugView/:projectId', component: () => import('@/views/ProjectBug/ProjectBugView.vue') },
  { name: '/testDetailView', path: '/TestRunsAndResults/testDetailView/', component: () => import('@/views/TestRunsAndResults/TestDetailView.vue') },
  { name: '/setting/settingOverView', path: '/setting/settingOverView', component: () => import('@/views/settings/SettingOverView.vue') },
  { name: '/selectCompanyView', path: '/selectCompany/selectCompanyView', component: () => import('@/views/SelectCompany/SelectCompanyView.vue') },
  { path: '/aiCaseOverview', component: () => import('@/views/AI/AICaseOverview.vue') },
  { path: '/aiInfoView', component: () => import('@/views/AI/AIInfoView.vue') },
  { path: '/personalSetingView', component: () => import('@/views/PersonalSetting/PersonalSetingView.vue') },
  { path: '/AiHubOverview', component: () => import('@/views/AIHub/AIHubOverview.vue') },
  { path: '/workOrderOverview', component: () => import('@/views/WorkOrder/WorkOrderOverview.vue') },
  { path: '/workOrderInfoview', component: () => import('@/views/WorkOrder/WorkOrderInfoview.vue') },
]

const router = new VueRouter({
  routes
})

// Navigation guard state management
const navigationState = {
  pending: false,
  currentNavigation: null,
  lastSuccessfulNavigation: null
}

// Helper to check if navigation is duplicate
function isDuplicateNavigation(to, from) {
  return to.name === from.name &&
    to.path === from.path &&
    JSON.stringify(to.params) === JSON.stringify(from.params) &&
    JSON.stringify(to.query) === JSON.stringify(from.query)
}

// Helper to cleanup navigation state
function cleanupNavigation() {
  if (navigationState.currentNavigation) {
    navigationState.currentNavigation = null
  }
  navigationState.pending = false
}

// Define routes that don't require authentication
const publicRoutes = ['/login', '/account-disabled', '/selectCompany/selectCompanyView']

function parseLocalJson(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || '{}') || {}
  } catch (error) {
    return {}
  }
}

function hasDashboardAuthContext() {
  const token = tokenManager.getToken() || ''
  const loginInfo = parseLocalJson('LoginInfo')
  return /^Token\s+\S+/.test(token) &&
    Boolean(loginInfo.id)
}

router.beforeEach(async (to, from, next) => {
  // 如果是重复导航，阻止
  if (isDuplicateNavigation(to, from)) {
    return next(false)
  }

  // 取消任何挂起的导航
  if (navigationState.pending && navigationState.currentNavigation) {
    navigationState.currentNavigation.abort()
    cleanupNavigation()
  }

  try {
    navigationState.pending = true
    navigationState.currentNavigation = {
      abort: () => {
        cleanupNavigation()
      }
    }

    // 1. 公共页面直接放行
    if (publicRoutes.includes(to.path)) {
      return next()
    }

    // 2. 其他页面需要校验 token
    const hasToken = await tokenManager.checkSession()
    if (!hasToken) {
      // 未登录，跳转登录页
      return next('/login')
    }
    if (to.path === '/dashboard' && !hasDashboardAuthContext()) {
      return next('/login')
    }

    // 3. 其他情况正常放行
    const isDashboard = from.path === '/dashboard'
    localStorage.setItem('TabDefaultValue', isDashboard ? 'true' : 'false')
    await new Promise(resolve => setTimeout(resolve, 50))
    next()
  } catch (error) {
    cleanupNavigation()
    next('/login')
  }
})

router.afterEach((to) => {
  navigationState.lastSuccessfulNavigation = {
    name: to.name,
    path: to.path,
    params: { ...to.params },
    query: { ...to.query }
  }
  cleanupNavigation()
})

router.onError((error) => {
  cleanupNavigation()
})

// Enhance router prototype methods
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationCancelled') {
      return Promise.resolve(false)
    }
    return;
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationCancelled') {
      return Promise.resolve(false)
    }
    return;
  })
}

export default router
